<template>
  <p>In 2017, two VizbiPlus Showcase events took place:</p>
  <ShowcaseEventList year="2017" />
</template>

<script setup>
import ShowcaseEventList from "@/components/ShowcaseEventList.vue";
</script>
